import React from "react";
import styled from "styled-components";


export default styled.div`
    display: flex;
    justify-content: space-between;
    align-items:center;
    border-bottom: 1px solid #cccccc;
`;